import { FC, ReactElement } from 'react'

import ConnectedBaseSchedule from './connectors/ConnectedBaseSchedule/ConnectedBaseSchedule'

const BaseSchedule: FC = (): ReactElement => (
    <ConnectedBaseSchedule />
)

export default BaseSchedule
